import Vue from "vue";
import VuePageTitle from "vue-page-title";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NProgress from "vue-nprogress";
import FirebaseAuthService from "./services/firebase";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueProgress from "vue-progress";
import VCalendar from "v-calendar";
import Vuelidate from "vuelidate";
import vueVimeoPlayer from "vue-vimeo-player";

import "mutationobserver-shim";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Roles from "./mixins/lists/Roles";
import Places from "./mixins/lists/Places";
import Languages from "./mixins/abouts/Languages";
import Timezones from "./mixins/abouts/Timezones";
import Spiritual from "./mixins/abouts/Spiritual";
import Political from "./mixins/abouts/Political";
import GuideAccountType from "./mixins/GuideAccountType";
import Moment from "./mixins/moment/Moment";
import moment from "moment";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueProgress);
Vue.use(VCalendar);
Vue.use(vueVimeoPlayer);
Vue.mixin(Roles);
Vue.mixin(Places);
Vue.mixin(Languages);
Vue.mixin(Timezones);
Vue.mixin(Spiritual);
Vue.mixin(Political);
Vue.mixin(GuideAccountType);
Vue.mixin(Moment);

Vue.prototype.$moment = moment;

Vue.use(NProgress);
Vue.use(Vuelidate);
Vue.use(FirebaseAuthService);
Vue.use(VuePageTitle, {
  prefix: " JourneyBinder | ",
  router
});

Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });

Vue.config.ignoredElements = ["journal-web-component"];

new Vue({
  router,
  store,
  nprogress,
  render: h => h(App)
}).$mount("#app");
